import React from 'react';
import './logos.scss';

const Logos = () => {
  return (
    <div className="logos-wrapper">
      <div className="logos-container">
      <img src="/googlelogo.png" alt="Logo 3" className="logo" />
        <img  src="/meta.avif" alt="Logo 1" className="logo" />
        <img src="/linked.png" alt="Logo 2" className="logo" />
      </div>
    </div>
  );
};

export default Logos;
